import * as React from "react"

const GridSvg = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="#E9ECEF"
        {...props}
        viewBox={'0 0 32 32'}
    >
        <rect width={32} height={32} fill="inherit" stroke={'none'} rx={2}/>
        <path
            fill="#333"
            stroke={'none'}
            d="M8 8h4v4H8V8Zm6 0h4v4h-4V8Zm6 0h4v4h-4V8ZM8 14h4v4H8v-4Zm6 0h4v4h-4v-4Zm6 0h4v4h-4v-4ZM8 20h4v4H8v-4Zm6 0h4v4h-4v-4Zm6 0h4v4h-4v-4Z"
        />
    </svg>
)

export default GridSvg